<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    header="Premium Difference Alert"
    :style="{ width: '30rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
    @hide="handleClose"
  >
    <div class="premium-dialog-content">
      <p class="mb-3">The premium is different from the quoted amount. Do you want to continue?</p>
      <div class="premium-details mt-3">
        <div class="mb-2">
          <strong>Quoted Premium:</strong>
          <span class="ms-2">
            <em class="rupee">&#x20B9;</em>
            {{ formatAmount(quotedPremium) }}
          </span>
        </div>
        <div>
          <strong>Received Premium:</strong>
          <span class="ms-2">
            <em class="rupee">&#x20B9;</em>
            {{ formatAmount(receivedPremium) }}
          </span>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="d-flex justify-content-center" style="flex-wrap: nowrap; gap: 10px;">
        <button type="button" class="backbutton btn" @click="handleNo">No</button>
        <button type="button" class="nextbutton btn" @click="handleYes">Yes</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
  name: 'PremiumDifferenceDialog',
  components: {
    Dialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    quotedPremium: {
      type: Number,
      required: true,
      default: 0,
    },
    receivedPremium: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      localVisible: this.visible,
    };
  },
  watch: {
    visible(val) {
      this.localVisible = val;
    },
    localVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    },
  },
  methods: {
    formatAmount(value) {
      const num = Number(value) || 0;
      return num.toLocaleString('en-IN');
    },
    handleClose() {
      this.localVisible = false;
      this.$emit('handleNo');
    },
    handleYes() {
      this.localVisible = false;
      this.$emit('handleYes');
    },
    handleNo() {
      this.localVisible = false;
      this.$emit('handleNo');
    },
  },
};
</script>
